import {
  KeyAction,
  HeadersVisibility,
  SelectionMode,
  AllowSorting,
  AllowResizing,
} from "@grapecity/wijmo.grid"

/********************************************
 *                                          *
 *           グリッドの列幅設定               *
 *                                          *
 ******************************************* */

/**
 * 2桁程度の数字列幅
 */
const COL_SMALL_NUMBER = 50 as const

/**
 * Gridの単位列幅
 * 検索虫眼鏡のみ
 */
const COL_SEARCH_ICON_SIZE_S = 30 as const

/**
 * GridのXXXXコード列幅
 */
const COL_CODE_SIZE = 120 as const

/**
 * GridのXXXX名称列幅
 */
const COL_NAME_SIZE = 360 as const

/**
 * カレンダーの列幅
 * YYYY/MM/DD
 */
const COL_CALENDAR_SIZE = 100 as const

/**
 * カレンダー入力の列幅
 * YYYY/MM/DD
 */
const COL_CALENDAR_INPUT_SIZE = 130 as const

/**
 * カレンダー入力の列幅
 * YYYY/MM/DD
 */
const COL_CALENDAR_WAREKI_INPUT_SIZE = 180 as const

/**
 * カレンダー時間ありの列幅
 * YYYY/MM/DD HH:MM:SS
 */
const COL_CALENDAR_TIME_SIZE = 150 as const

/**
 * カレンダーFromToの列幅
 * YYYY/MM/DD ~ YYYY/MM/DD
 */
const COL_CALENDAR_FROM_TO_SIZE = 150 as const

/********************************************
 *                                          *
 *           FlexGridのオプションセット       *
 *                                          *
 ******************************************* */
/**
 * 編集不可Gridの設定
 */
const FLEX_GRID_PROPS = {
  isReadOnly: true, // 編集不可
  headersVisibility: HeadersVisibility.Column, // 行ヘッダおよび列ヘッダが表示
  selectionMode: SelectionMode.MultiRange, // 現在の選択モード
  stickyHeaders: true, // スクロールしたときに、 列ヘッダーを表示
  alternatingRowStep: 0, // 「交互行」の間の通常行の数
  allowMerging: "ColumnHeaders", // セル結合
  showMarquee: true,
  imeEnabled: true,
} as const

/**
 * 編集可能Gridの設定
 */
const FLEX_GRID_PROPS_EDIT = {
  allowAddNew: true, // グリッドに新規行テンプレートを表示する
  allowDelete: true, // ［Delete］キーを押したときにグリッドの選択されている行を削除する
  showMarquee: true, // 現在の選択範囲の周囲にマーキー要素を表示
  keyActionTab: KeyAction.CycleOut, // ［Tab］キーが押されたときに実行されるアクション => 次の列に移動し、次の行に折り返してからコントロールの外に移動します。
  alternatingRowStep: 0, // 「交互行」の間の通常行の数
  selectionMode: SelectionMode.MultiRange, // 現在の選択モード
  headersVisibility: HeadersVisibility.All, // 行ヘッダおよび列ヘッダ表示
  width: "*",
  imeEnabled: true,
} as const

/**
 * 合計Gridの設定
 */
const FLEX_GRID_PROPS_TOTAL = {
  headersVisibility: HeadersVisibility.Column, // 行ヘッダおよび列ヘッダが表示
  selectionMode: SelectionMode.None, // 現在の選択モード
  isReadOnly: true, // 編集不可
  allowSorting: AllowSorting.None, // 列をソートできるか
  allowResizing: AllowResizing.None, // マウスを使用して行、列、またはその両方をサイズ変更できるか
  allowMerging: "ColumnHeaders", // セル結合を許可するか
  imeEnabled: true,
} as const

const GRID_PROPERTY_SET = {
  FLEX_GRID_PROPS,
  FLEX_GRID_PROPS_EDIT,
  FLEX_GRID_PROPS_TOTAL,
} as const

export type GRID_PROPERTY_SET_TYPE =
  typeof GRID_PROPERTY_SET[keyof typeof GRID_PROPERTY_SET]

const GRID = {
  PROPERTY_SET: GRID_PROPERTY_SET,
  COL_SIZE: {
    COL_SMALL_NUMBER,
    COL_SEARCH_ICON_SIZE_S,
    COL_CODE_SIZE,
    COL_NAME_SIZE,
    COL_CALENDAR_SIZE,
    COL_CALENDAR_INPUT_SIZE,
    COL_CALENDAR_WAREKI_INPUT_SIZE,
    COL_CALENDAR_TIME_SIZE,
    COL_CALENDAR_FROM_TO_SIZE,
  },
}

export default GRID
